import React, { Component, Fragment } from "react";
import withRouter from "../withRouter/withRouter";

import "./Checkout.css";
import no_image_img from "../../no-image.png";
import closed_image from "../../icons/closed-n.webp";
import { toPersianNumber } from "../../classes/utils";

class Checkout extends Component {
    constructor(props) {
        super(props);

        this.formRef = React.createRef();

        this.on_shipping_method_select =
            this.on_shipping_method_select.bind(this);
        this.on_province_change = this.on_province_change.bind(this);
        this.calculate_total_price = this.calculate_total_price.bind(this);
        this.submit = this.submit.bind(this);
        this.checkout = this.checkout.bind(this);
    }

    shipping_methods = [
        { en: "post", fa: "پست پیشتاز" },
        { en: "freight", fa: "کرایه در مقصد پست" },
        { en: "tipax", fa: "تیپاکس" },
    ];

    check_requested = false;
    prevCart = [];

    componentDidMount() {
        let { connection, costumer } = this.props;
        costumer = costumer || {};
        connection &&
            connection
                .get_shipping_info()
                .then((res) => {
                    costumer.address = res.data.address;
                    costumer.mobile = res.data.mobile;
                    costumer.name = res.data.name;
                    costumer.zip = res.data.zip;
                    costumer.city = res.data.city;
                    costumer.province = res.data.province || -1;
                    this.setState({ costumer });
                    this.on_province_change(costumer.province);
                })
                .catch((err) => {
                    console.log(err);
                });

        connection &&
            connection
                .get_costs()
                .then((res) => {
                    this.setState({ costs: res.data });
                    this.on_province_change(costumer.province);
                })
                .catch((err) => {
                    console.log(err);
                });

        connection &&
            connection
                .get_cities()
                .then((res) => {
                    this.setState({
                        cities: res.data,
                    });
                })
                .catch((err) => {
                    console.log(err);
                });

        this.componentDidUpdate();
    }

    componentDidUpdate() {
        let { cart, connection } = this.props;

        if (cart.length !== this.state.cart.length) {
            this.setState({ cart });
        }
        this.prevCart.length != cart.length &&
            (this.prevCart = JSON.parse(JSON.stringify(cart))) &&
            !this.check_requested &&
            cart &&
            cart.length > 0 &&
            connection &&
            this.checkout(cart, this.state.coupon);
    }

    checkout(cart) {
        let { connection } = this.props;
        this.check_requested = true;
        connection
            .check_cart({ cart, coupon: this.state.coupon_code })
            .then((res) => {
                let checkout = res.data;
                this.setState({ checkout });
                let { shipping_method, province } = this.state;

                if (!checkout.isOrderingOpen) {
                    this.props.toast(
                        "سفارش گذاری بسته است.",
                        "مشتری گرامی در حال حاضر سفارش گذاری وبسایت بسته است. شما میتوانید به محض در دسترس قرار گرفتن وبسایت سفارش خود را تکمیل کنید.",
                        " danger",
                        10
                    );
                }

                this.get_shipping_cost(shipping_method, province, checkout);
            })
            .catch((err) => {
                this.componentDidUpdate();
            })
            .finally(() => {
                this.check_requested = false;
            });
    }

    on_shipping_method_select(ev) {
        let method = ev.target.name.replace("shipping_", "");
        this.setState({
            shipping_method: method,
        });
        let { checkout, province, shipping_costs } = this.state;

        this.get_shipping_cost(method, province, checkout);
        this.calculate_total_price(shipping_costs[method]);
    }

    on_province_change(province) {
        this.setState({ province });
        let { shipping_method, checkout } = this.state;

        this.get_shipping_cost(shipping_method, province, checkout);
    }

    get_shipping_cost(method, province_code, checkout) {
        let { connection } = this.props;

        checkout &&
            (method === "post" ? province_code : true) &&
            connection &&
            connection
                .get_shipping_cost(
                    checkout.totalWeight,
                    method,
                    parseInt(province_code || 0)
                )
                .then((res) => {
                    let { shipping_costs } = this.state;
                    shipping_costs[method] = res.data.cost;
                    this.setState({ shipping_costs });
                    this.calculate_total_price(shipping_costs[method]);
                })
                .catch((err) => {});
    }

    calculate_total_price(shipping_cost) {
        let { checkout } = this.state;
        let { totalItemsPrice, packingPrice } = checkout;

        if (!parseInt(shipping_cost)) {
            shipping_cost = 0;
        }

        totalItemsPrice &&
            packingPrice &&
            this.setState({
                total: totalItemsPrice + packingPrice + shipping_cost,
            });
    }

    on_change(ev) {
        let el = ev.target;
        let invalid = false;
        switch (el.name) {
            case "city":
                invalid = el.value < 0;
                break;

            case "address":
                invalid = el.value.length < 10;
                break;

            case "name":
                invalid = el.value.length < 3;
                break;

            case "zip":
                invalid = el.value.length !== 10;
                break;

            case "mobile":
                invalid = el.value.length !== 11;
                break;
        }
        if (invalid) {
            el.classList.add("invalid");
            return;
        }
        if (!invalid) {
            el.classList.remove("invalid");
        }
    }

    submit() {
        if (this.state.checkoutReqSent) return;
        let { costumer } = this.state;
        let formData = Object.fromEntries(new FormData(this.formRef.current));
        Object.keys(formData).forEach((key) => {
            if (key.includes("shipping_")) {
                if (formData[key] === "on") {
                    formData.shipping = key.replace("shipping_", "");
                }
                delete formData[key];
            }
        });

        if (!formData["accept-terms"]) {
            this.props.toast(
                "پذیرش قوانین",
                "پذیرش قوانین الزامی است",
                " danger"
            );

            return;
        }

        let {
            name,
            address,
            city,
            mobile,
            payment,
            province,
            shipping,
            zip,
            comment,
            coupon,
        } = formData;

        if (
            !name ||
            !address ||
            address.length < 10 ||
            !city ||
            !province ||
            !mobile ||
            mobile.length < 11 ||
            !payment ||
            !shipping
        ) {
            this.props.toast(
                "ورودی های ناقص",
                "لطفا ورودی هارا چک کنید و آنهایی که با رنگ قرمز مشخص شده اند را اصلاح نمایید",
                " danger"
            );
            return;
        }

        let { connection, router, toast } = this.props;
        let { cart } = this.state;
        this.setState({ checkoutReqSent: true });

        connection
            .order({
                name,
                items: cart,
                address,
                city,
                mobile,
                payment,
                province,
                shipping,
                zip,
                comment,
                coupon,
            })
            .then((res) => {
                this.setState({ cart: [] });
                if (payment === "offline")
                    router.navigate(`/pay/${payment}/${res.data.id}/${mobile}`);
                if (payment === "online")
                    window.open(res.data.online_payment_url, "_self");
                this.props.clear_cart();
            })
            .catch((err) => {
                toast("خطا", "خطا در تکمیل سفارش : " + err, " danger");
            })
            .finally(() => {
                this.setState({ checkoutReqSent: false });
            });
    }

    affect_discount(before, effect) {
        return effect && effect.value > 0
            ? parseInt(
                  effect.type === "percent"
                      ? parseInt(before * ((100 - effect.value) / 100)) || 0
                      : parseInt(before - effect.value) || 0
              ).toString()
            : parseInt(before);
    }

    state = {
        cart: this.props.cart,
        checkout: null,
        shipping_costs: {
            freight: "پس کرایه",
            tipax: "پس کرایه",
            post: null,
        },
        shipping_method: "post",
        address: null,
        cities: [],
        total: 0,
        costumer: {},
        coupon: null,
        checkoutReqSent: false,
        coupon_code: "",
    };

    render() {
        let { connection } = this.props;

        let {
            cart,
            checkout,
            shipping_costs,
            shipping_method,
            costumer,
            cities,
            total,
            costs,
        } = this.state;
        let {
            check,
            totalItemsPrice,
            totalWeight,
            packingPrice,
            coupon_status,
            coupon_effect,
        } = checkout || {};
        let { province, address, mobile, name, zip, city } = costumer || {};
        let after_discount =
            totalItemsPrice &&
            packingPrice &&
            shipping_costs &&
            coupon_status === 200 &&
            coupon_effect &&
            shipping_costs[shipping_method] != null
                ? parseInt(
                      this.affect_discount(totalItemsPrice, coupon_effect.cart)
                  ) +
                  parseInt(
                      this.affect_discount(packingPrice, coupon_effect.packing)
                  ) +
                  parseInt(
                      this.affect_discount(
                          shipping_costs[shipping_method],
                          coupon_effect.shipping
                      )
                  )
                : null;

        return (
            <div className='CheckoutComponent'>
                {cart && cart.length > 0 ? (
                    <div className='checkout'>
                        <div className='items'>
                            <div className='caption'>سبد خرید</div>
                            {cart.map((item, index) => {
                                let {
                                    thumbnail,
                                    name,
                                    amount,
                                    unit,
                                    color,
                                    id,
                                } = item;
                                !thumbnail &&
                                    (thumbnail = { url: no_image_img });

                                return (
                                    <div className='item' key={index}>
                                        <div className='image'>
                                            <img src={thumbnail.url} alt='' />
                                        </div>
                                        <a
                                            className='name text primary'
                                            href={"/item/" + id}
                                        >
                                            {name}
                                        </a>
                                        <div
                                            className='color'
                                            style={{
                                                color: color.color,
                                            }}
                                        >
                                            {color.name || (
                                                <div
                                                    className='colorCircle'
                                                    style={{
                                                        backgroundColor:
                                                            color.color,
                                                    }}
                                                ></div>
                                            )}
                                        </div>
                                        <div className='amount text secondary'>
                                            {`${toPersianNumber(
                                                parseFloat(amount),
                                                true
                                            )}  ${unit}`}
                                        </div>

                                        <div className='price text secondary'>
                                            {check && check.length > 0 ? (
                                                <div>
                                                    {`${toPersianNumber(
                                                        check[index].price,
                                                        true
                                                    )}  تومان`}
                                                </div>
                                            ) : (
                                                <div className='checking'>
                                                    <i className='ri-loader-line text info'></i>
                                                </div>
                                            )}
                                        </div>
                                        <div className='check'>
                                            {check && check.length > 0 ? (
                                                check[index].amount &&
                                                check[index].step &&
                                                check[index].min &&
                                                check[index].price > 0 ? (
                                                    <div className='valid'>
                                                        <i className='ri-check-line text confirm'></i>
                                                    </div>
                                                ) : (
                                                    <div className='invalid'>
                                                        <i className='ri-error-warning-line text danger'></i>
                                                        {(!check[index]
                                                            .amount ||
                                                            !check[index].min ||
                                                            !check[index]
                                                                .step) && (
                                                            <span className='reason danger text'>
                                                                مقدار غیر مجاز
                                                            </span>
                                                        )}
                                                    </div>
                                                )
                                            ) : (
                                                <div className='checking'>
                                                    <i className='ri-loader-line text info'></i>
                                                </div>
                                            )}
                                        </div>

                                        <div
                                            className='delete '
                                            onClick={(ev) => {
                                                this.props.deleteFromCart(
                                                    index
                                                );
                                                this.checkout(
                                                    cart,
                                                    this.state.coupon_code
                                                );
                                            }}
                                        >
                                            <i className='ri-delete-bin-7-fill btn danger'></i>
                                        </div>
                                    </div>
                                );
                            })}
                            {totalItemsPrice && (
                                <div className='totalItemsPrice'>
                                    <div className='caption text info'>
                                        کل قیمت اجناس
                                    </div>
                                    <div className='price'>
                                        {`${toPersianNumber(
                                            totalItemsPrice,
                                            true
                                        )}  تومان`}
                                    </div>
                                </div>
                            )}
                        </div>
                        <form id='form' ref={this.formRef}></form>

                        {checkout?.isOrderingOpen ? (
                            <>
                                {packingPrice && (
                                    <div className='packingPrice'>
                                        <div className='caption'>
                                            هزینه بسته بندی
                                        </div>
                                        {costs && (
                                            <div className='description'>
                                                سفارشات زیر
                                                {toPersianNumber(
                                                    costs.packing_price_limit,
                                                    true
                                                )}
                                                کیلو گرم مبلغ
                                                {toPersianNumber(
                                                    costs.packing_price_low_limit,
                                                    true
                                                )}
                                                تومان و سفارشات بیشتر از
                                                {toPersianNumber(
                                                    costs.packing_price_limit,
                                                    true
                                                )}
                                                کیلوگرم مبلغ
                                                {toPersianNumber(
                                                    costs.packing_price_up_limit,
                                                    true
                                                )}
                                                تومان
                                            </div>
                                        )}

                                        <div className='price'>
                                            {`${toPersianNumber(
                                                packingPrice,
                                                true
                                            )}  تومان`}
                                        </div>
                                    </div>
                                )}
                                <div className='address'>
                                    <div className='caption'>آدرس </div>
                                    <div className='name '>
                                        <div className='caption mandatory'>
                                            نام و نام خانوادگی گیرنده
                                        </div>
                                        <input
                                            type='name'
                                            name='name'
                                            onChange={this.on_change}
                                            form='form'
                                            defaultValue={name}
                                        />
                                    </div>

                                    {cities.length > 0 && (
                                        <div className='province mandatory'>
                                            <select
                                                name='province'
                                                type='province'
                                                defaultValue={province || -1}
                                                key={province}
                                                onChange={(ev) =>
                                                    this.on_province_change(
                                                        ev.target.value
                                                    )
                                                }
                                                form='form'
                                            >
                                                <option
                                                    value='-1'
                                                    disabled
                                                    key={-1}
                                                >
                                                    استان خود را انتخاب کنید
                                                </option>
                                                {cities
                                                    .sort((a, b) => {
                                                        return b.province_name >
                                                            a.province_name
                                                            ? -1
                                                            : 1;
                                                    })
                                                    .map((p) => {
                                                        return (
                                                            <option
                                                                value={
                                                                    p.province_code
                                                                }
                                                                key={
                                                                    p.province_code
                                                                }
                                                            >
                                                                {
                                                                    p.province_name
                                                                }
                                                            </option>
                                                        );
                                                    })}
                                            </select>
                                        </div>
                                    )}

                                    {this.state.province &&
                                        cities.length > 0 && (
                                            <div className='city mandatory'>
                                                <select
                                                    name='city'
                                                    type='city'
                                                    defaultValue={city || -1}
                                                    onChange={this.on_change}
                                                    form='form'
                                                >
                                                    <option value='-1' disabled>
                                                        شهر خود را انتخاب کنید
                                                    </option>
                                                    {(
                                                        (
                                                            cities.find((p) => {
                                                                return (
                                                                    p.province_code ===
                                                                    this.state
                                                                        .province
                                                                );
                                                            }) || {}
                                                        ).cities || []
                                                    )
                                                        .sort((a, b) => {
                                                            return b.name >
                                                                a.name
                                                                ? -1
                                                                : 1;
                                                        })
                                                        .map((city) => {
                                                            return (
                                                                <option
                                                                    value={
                                                                        city.code
                                                                    }
                                                                    key={
                                                                        city.code
                                                                    }
                                                                >
                                                                    {city.name}
                                                                </option>
                                                            );
                                                        })}
                                                </select>
                                            </div>
                                        )}

                                    <div className='postalAddress'>
                                        <div className='caption mandatory'>
                                            آدرس پستی
                                        </div>
                                        <textarea
                                            name='address'
                                            type='address'
                                            cols='30'
                                            rows='3'
                                            form='form'
                                            onChange={this.on_change}
                                            defaultValue={address}
                                        ></textarea>
                                    </div>
                                    <div className='zip'>
                                        <div className='caption'>کد پستی</div>
                                        <input
                                            type='zip'
                                            name='zip'
                                            pattern='[0-9]{10}'
                                            maxLength={10}
                                            minLength={10}
                                            onChange={this.on_change}
                                            form='form'
                                            defaultValue={zip}
                                            required={false}
                                        />
                                    </div>
                                    <div className='mobile '>
                                        <div className='caption mandatory'>
                                            شماره تلفن / موبایل
                                        </div>
                                        <input
                                            type='tel'
                                            name='mobile'
                                            onChange={this.on_change}
                                            form='form'
                                            defaultValue={mobile}
                                        />
                                    </div>
                                </div>

                                <div className='shipping'>
                                    <div className='caption text primary'>
                                        انتخاب روش ارسال سفارش
                                    </div>
                                    <div className='methods'>
                                        {this.shipping_methods.map((method) => {
                                            return (
                                                <div
                                                    className={method.en}
                                                    key={method.en}
                                                >
                                                    <input
                                                        type='checkbox'
                                                        name={`shipping_${method.en}`}
                                                        form='form'
                                                        onClick={
                                                            this
                                                                .on_shipping_method_select
                                                        }
                                                        checked={
                                                            shipping_method ===
                                                            method.en
                                                        }
                                                        onChange={(ev) => {}}
                                                    />
                                                    <img
                                                        src={
                                                            connection.baseURL +
                                                            "/files/icons/shipping_" +
                                                            method.en +
                                                            ".jpg"
                                                        }
                                                    />
                                                    <div className='name'>
                                                        {method.fa}
                                                    </div>
                                                    {!shipping_costs[
                                                        method.en
                                                    ] &&
                                                    method.en === "post" ? (
                                                        <div className='cost'>
                                                            (استان را مشخص
                                                            کنید.)
                                                        </div>
                                                    ) : (
                                                        <div className='cost'>
                                                            {(method.en ===
                                                                "freight" ||
                                                                method.en ===
                                                                    "tipax") &&
                                                                `پس کرایه `}
                                                            {/* {parseInt(
                                                                shipping_costs[
                                                                    method.en
                                                                ]
                                                            )
                                                                ? `${toPersianNumber(
                                                                      shipping_costs[
                                                                          method
                                                                              .en
                                                                      ],
                                                                      true
                                                                  )} تومان`
                                                                : shipping_costs[
                                                                      method.en
                                                                  ]}
                                                            {method.en ===
                                                                "freight" &&
                                                                `  کرایه شهری`} */}
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                    {shipping_method === "post" && (
                                        <Fragment>
                                            <div className='attention text warning'>
                                                <i className='ri-error-warning-line text '></i>
                                                هزینه ارسال با پست پیشتاز
                                                مستقیما از شرکت پست استعلام
                                                گرفته میشود. اما ممکن است هنگام
                                                دریافت بسته هزینه درج شده روی
                                                فاکتور با این هزینه متفاوت باشد.
                                                دلیل آن هزینه هایی مانند حق شیفت
                                                و حق انبارداری و هزینه حمل تا
                                                دفاتر پستی و پرینت لیبل و ...
                                                میباشد که در فاکتور همراه با جنس
                                                قید نشده اما از فرستنده دریافت
                                                میشود.
                                            </div>
                                            <div className='attention text warning'>
                                                <i className='ri-error-warning-line text '></i>
                                                وزن بسته های پستی بیش تر از
                                                {toPersianNumber("20", true)}
                                                کیلوگرم نمیتواند باشد بنابر این
                                                سفارشات بیشتر از
                                                {toPersianNumber("20", true)}
                                                کیلوگرم به دو یا چند بسته ی
                                                حداکثر
                                                {toPersianNumber("20", true)}
                                                کیلوگرمی تقسیم خواهد شد
                                            </div>
                                        </Fragment>
                                    )}
                                </div>

                                <div className='comment'>
                                    <div className='caption'>یادداشت </div>
                                    <textarea
                                        name='comment'
                                        id=''
                                        rows='5'
                                        form='form'
                                        placeholder='لطفا اگر در مورد نحوه ارسال کالا زمان ارسال یا هر توضیحات دیگری که دارید در این قسمت برای ما بنویسید.'
                                    ></textarea>
                                </div>

                                <div className='coupons'>
                                    <div className='caption'>کد تخفیف</div>
                                    <input
                                        type='text'
                                        name='coupon'
                                        form='form'
                                        onChange={(ev) => {
                                            this.setState({
                                                ...this.state,
                                                coupon_code: ev.target.value,
                                            });
                                        }}
                                    />
                                    <button
                                        className='verify btn confirm'
                                        onClick={(ev) => {
                                            this.checkout(
                                                this.state.cart,
                                                this.state.coupon
                                            );
                                        }}
                                    >
                                        <i className='fa-solid fa-rotate'></i>
                                        چک کردن کد تخفیف
                                    </button>
                                    <div className='status'>
                                        {coupon_status &&
                                            (coupon_status === 200 ? (
                                                <div className='verified text primary'>
                                                    کد تخفیف اعمال شد میتوانید
                                                    در فاکتور زیر تاثیر آنرا
                                                    مشاهده کنید.
                                                </div>
                                            ) : (
                                                <div className='not-verified text danger'>
                                                    کد تخفیف غیر مجاز میباشد.
                                                </div>
                                            ))}
                                    </div>
                                </div>

                                <div className='invoice'>
                                    <div className='caption'>فاکتور نهایی</div>
                                    <div className='items'>
                                        <div className='name'>کالاها</div>
                                        <div className='price'>
                                            {totalItemsPrice &&
                                                `${toPersianNumber(
                                                    totalItemsPrice.toString(),
                                                    true
                                                )} `}
                                        </div>
                                        {coupon_status === 200 &&
                                            coupon_effect && (
                                                <div className='after_discount price'>
                                                    {`${toPersianNumber(
                                                        this.affect_discount(
                                                            totalItemsPrice,
                                                            coupon_effect.cart
                                                        ).toString(),
                                                        true
                                                    )} `}
                                                </div>
                                            )}
                                    </div>
                                    <div className='packing'>
                                        <div className='name'>بسته بندی</div>
                                        <div className='price'>
                                            {packingPrice &&
                                                `${toPersianNumber(
                                                    packingPrice,
                                                    true
                                                )} `}
                                        </div>
                                        {coupon_status === 200 && (
                                            <div className='after_discount price'>
                                                {`${toPersianNumber(
                                                    this.affect_discount(
                                                        packingPrice,
                                                        coupon_effect.packing
                                                    ).toString(),
                                                    true
                                                )} `}
                                            </div>
                                        )}
                                    </div>
                                    <div className='shipping'>
                                        <div className='name'>ارسال</div>
                                        <div className='price'>
                                            {shipping_costs &&
                                            shipping_costs[shipping_method] !=
                                                null ? (
                                                parseInt(
                                                    shipping_costs[
                                                        shipping_method
                                                    ]
                                                ) > 0 ? (
                                                    `${toPersianNumber(
                                                        shipping_costs[
                                                            shipping_method
                                                        ].toString(),
                                                        true
                                                    )} `
                                                ) : (
                                                    shipping_costs[
                                                        shipping_method
                                                    ]
                                                )
                                            ) : (
                                                <div className='text text danger'>
                                                    <i className='fa-solid fa-triangle-exclamation'></i>
                                                    ابتدا استان خود را انتخاب
                                                    نمایید
                                                </div>
                                            )}
                                        </div>
                                        {coupon_status === 200 &&
                                            (shipping_costs[shipping_method] !=
                                            null ? (
                                                <div className='after_discount price'>
                                                    {`${toPersianNumber(
                                                        this.affect_discount(
                                                            shipping_costs[
                                                                shipping_method
                                                            ],
                                                            coupon_effect.shipping
                                                        ).toString(),
                                                        true
                                                    )} `}
                                                </div>
                                            ) : (
                                                <div className='text text danger'>
                                                    <i className='fa-solid fa-triangle-exclamation'></i>
                                                    ابتدا استان خود را انتخاب
                                                    نمایید
                                                </div>
                                            ))}
                                    </div>
                                    <div className='total'>
                                        <div className='name'>جمع کل</div>
                                        <div className='price'>
                                            {totalItemsPrice &&
                                                packingPrice &&
                                                shipping_costs &&
                                                shipping_costs[
                                                    shipping_method
                                                ] != null &&
                                                `${toPersianNumber(
                                                    total,
                                                    true
                                                )}  `}
                                        </div>
                                        {coupon_status === 200 &&
                                            after_discount != null && (
                                                <div className='after_discount price'>
                                                    {`${toPersianNumber(
                                                        after_discount.toString(),
                                                        true
                                                    )} `}
                                                </div>
                                            )}
                                    </div>
                                    {coupon_status === 200 &&
                                        after_discount != null && (
                                            <div>
                                                <div className='name'>
                                                    مقدار کل تخفیف شما
                                                </div>

                                                <div className='total_discount'>
                                                    {`${toPersianNumber(
                                                        (
                                                            total -
                                                            after_discount
                                                        ).toString(),
                                                        true
                                                    )} تومان`}
                                                </div>
                                            </div>
                                        )}
                                </div>

                                <div className='payment'>
                                    <div className='caption'>روش پرداخت</div>
                                    <div className='methods'>
                                        <div className='online '>
                                            <input
                                                type='radio'
                                                name='payment'
                                                form='form'
                                                value={"online"}
                                                defaultChecked
                                            />
                                            <img
                                                src={
                                                    connection.baseURL +
                                                    "/files/icons/payment_online.png"
                                                }
                                                alt=''
                                            />
                                            <div className='name'>
                                                پرداخت آنلاین
                                            </div>
                                        </div>
                                        <div className='manual'>
                                            <input
                                                type='radio'
                                                name='payment'
                                                form='form'
                                                value={"offline"}
                                            />
                                            <img
                                                src={
                                                    connection.baseURL +
                                                    "/files/icons/payment_offline.png"
                                                }
                                            />
                                            <div className='name'>
                                                پرداخت آفلاین
                                                <div className='hint'>
                                                    (کارت به کارت / حساب به حساب
                                                    / پایا)
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='_attention offline'>
                                        <div className='attention text info'>
                                            <i className='ri-error-warning-line text '></i>
                                            در روش "ثبت فیش واریز" سفارش شما به
                                            صورت موقت ثبت میشود و یک پیش فاکتور
                                            همراه با شماره فاکتور برای شما صادر
                                            میشود سپس شما با استفاده از روش های
                                            (کارت به کارت / حساب به حساب / پایا
                                            ) اقدام به پرداخت پیش فاکتور نموده و
                                            اطلاعات واریز وجه را از طریق سایت
                                            برای ما ارسال میکنید. پس از تایید
                                            پرداخت توسط مدیر سایت سفارش شما
                                            تایید میشود.
                                        </div>
                                        <div className='attention text danger'>
                                            <i className='ri-error-warning-line text '></i>
                                            در صفحه بعد شماره پیش فاکتور به شما
                                            نمایش داده میشود این شماره را همراه
                                            شماره موبایلی که در بالا وارد کردید
                                            حتما ذخیره کنید زیرا . در زمان ارسال
                                            اطلاعات واریز وارد نمودن شماره پیش
                                            فاکتور و موبایل برای مشخص کردن سفارش
                                            الزامی میباشد.
                                        </div>
                                    </div>
                                </div>
                                <div className='pay'>
                                    <div className='accept-terms'>
                                        <input
                                            type='checkbox'
                                            name='accept-terms'
                                            id='accept-terms'
                                            form='form'
                                        />
                                        <label
                                            className='caption text info'
                                            htmlFor='accept-terms'
                                        >
                                            اینجانب ضمن مطالعه بخش
                                            <a
                                                href='/rules'
                                                className='text danger'
                                            >
                                                {" "}
                                                قوانین و مقررات و وبسایت{" "}
                                            </a>
                                            تمامی این موارد را می پذیرم.
                                            <div className='text warning'>
                                                (ارسال سفارشات بین 3 تا هفت روز
                                                کاری زمان میبرد.)
                                            </div>
                                        </label>
                                    </div>
                                    <button
                                        className='submit btn confirm'
                                        type='submit'
                                        onClick={this.submit}
                                        disabled={this.state.checkoutReqSent}
                                    >
                                        {this.state.checkoutReqSent
                                            ? "در حال پردازش. لطفا صبر کنید..."
                                            : "ثبت سفارش و پرداخت"}
                                    </button>
                                </div>
                            </>
                        ) : (
                            <div
                                style={{
                                    textAlign: "center",
                                    color: "red",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyItems: "center",
                                    alignItems: "center",
                                }}
                            >
                                <img
                                    src={closed_image}
                                    style={{
                                        width: "300px",
                                        height: "300px",
                                        objectFit: "fill",
                                    }}
                                />
                                <i
                                    className='ri-rest-time-line'
                                    style={{
                                        color: "red",
                                        fontSize: "50px",
                                    }}
                                ></i>
                                <div
                                    style={{
                                        fontSize: "22px",
                                        textAlign: "center",
                                    }}
                                >
                                    مشتری گرامی در حال حاضر سفارش گذاری وبسایت
                                    بسته است.
                                </div>
                            </div>
                        )}
                    </div>
                ) : (
                    <div className='empty_cart text danger'>
                        <i className='ri-close-circle-line '></i>
                        سبد خرید شما خالی است.
                    </div>
                )}
            </div>
        );
    }
}

export default withRouter(Checkout);
